/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';

export default class BlankLayout extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {'body' : this.props.body || ''}
    }

    componentWillMount(){
        document.getElementsByTagName("body")[0].setAttribute("data-ma-header", "none");
    }

    render(){
        return (<div>{this.props.children}</div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/blank-page.js